/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type React from 'react';

/**
 * Rythme vertical d'un titre de section (`SectionHeader`) dans un formulaire.
 *
 * Trois fois plus d'air au-dessus qu'en dessous : un titre à marge symétrique se
 * retrouve aussi près du dernier champ du bloc PRÉCÉDENT que de ses propres
 * champs, et se lit comme la suite de ce qui le précède.
 *
 * Nommé plutôt que recopié : la valeur vit sur plusieurs sites, et une valeur
 * dupliquée dérive au premier ajustement.
 */

/**
 * Air AU-DESSUS d'un bloc, exporté à part : `ChampAdresse` le porte sur un
 * conteneur, son titre étant rendu par la lib dans la ligne des boutons radio.
 */
export const ESPACE_AVANT_SECTION = '1.5em';

export const ESPACE_APRES_SECTION = '0.5em';

export const STYLE_TITRE_SECTION: React.CSSProperties = {
  margin: `${ESPACE_AVANT_SECTION} 0 ${ESPACE_APRES_SECTION}`,
};

export default STYLE_TITRE_SECTION;
